import React from 'react';
import cx from 'classnames';
import styles from './Badge.module.scss';
const Badge = ({ className, status = 'default', size = 'md', value = null, }) => {
    let appendSign;
    if (status === 'removed')
        appendSign = '-';
    if (status === 'added')
        appendSign = '+';
    return (React.createElement("div", { className: cx(styles.container, className, styles[`status-${status}`], styles[`size-${size}`]) },
        appendSign,
        value));
};
export default Badge;
